<template>
  <div class="Item" :class="{
    'Item--active' : props.isActive,
  }">
    <template v-if="props.isPon">
      <div class="Item__pon-item">
        <img class="Item__pon-icon" :src="ponAvatar" height="24px" width="24px" />
        <span class="Item__pon-name">PoN</span>
        <span class="Item__pon-subname">NFT</span>
      </div>
    </template>
    <template v-else>
      <div class="Item__subscribe-item">
        <div class="Item__subscribe-item-grouop">
          <span class="Item__days">{{ props.days }}</span>
          <span class="Item__month">месяцев</span>
        </div>
        <span class="Item__tag" :class="{
          'Item__tag Item__tag--primary': props.tagStyle === 'primary',
          'Item__tag Item__tag--secondary': props.tagStyle === 'secondary',
          'Item__tag Item__tag--default': props.tagStyle === 'default',
        }">
          {{ props.tag }}
        </span>
      </div>
    </template>
    <span class="Item__price">
      {{ props.price }} <span class="Item__currency">{{ props.currency }}</span>
    </span>
    <span class="Item__value">
      {{ props.value }}
    </span>
    <div class="Item__check" v-if="props.isActive">
      <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
        <path d="M2.79755 6L0 3.15593L0.699386 2.44491L2.79755 4.57796L7.30061 0L8 0.711019L2.79755 6Z" fill="white" />
      </svg>
    </div>
  </div>
</template>

<script setup>
  import { Props } from './props';
  //-----------------------------
  const props = defineProps(Props());
  //-----------------------------
  const ponAvatar = require("./images/pon.png");
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>